import { observer } from 'mobx-react-lite';
import { StockResponse } from '../../../server/response/responseSchema';
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';

/**
 * 종목 이미지
 */
export const StockLogo = observer(
    ({
        size,
        stock,
        altName,
    }: {
        size: 6 | 10;
        stock?: StockResponse | null;
        // stock 이 없을 경우 대체명
        altName?: string;
    }) => {
        let sizeClassName = '';
        if (size === 6) {
            sizeClassName = 'size-6';
        } else if (size === 10) {
            sizeClassName = 'size-10';
        }

        if (stock?.hasLogo) {
            return (
                <div className="avatar">
                    <div className={twMerge('bg-base-300 size-full rounded-full', sizeClassName)}>
                        <img
                            src={`${import.meta.env.VITE_IMAGE_PATH}/stock_logo/${stock.hash}_thumb.webp`}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="avatar avatar-placeholder">
                    <div className={twMerge('bg-base-300 size-full rounded-full', sizeClassName)}>
                        <span className="text-base-content/30 font-bold">
                            {_.first(stock?.ticker || stock?.name || altName || '')}
                        </span>
                    </div>
                </div>
            );
        }
    },
);

export default StockLogo;
